import { ListPageBase } from "../../../shared/components/list-page-base/list-page-base";
import { AgreementListItem } from '../../../shared/models/agreement/agreement-list-item';
import { StatePersistingService } from "../../../shared/services/state-persisting.service";
import { AgreementsService } from '../../../shared/services/agreements.service';
import { AppService } from "../../../app.service";
import { Router } from "@angular/router";
import { LookupService } from "../../../shared/services/lookup.service";
import { KeyValueObject } from "../../../shared/models/core/KeyValueObject";
import { Component } from "@angular/core";
import { ExportExcelFromGridService } from "../../../shared/services/export-excel-from-grid.service";
import { GridSettings } from "../../../shared/models/grid/grid-settings";
import { UsersService } from "../../../admin/users/users.service";

@Component({
	selector: 'agreement-list',
	templateUrl: './list.page.html',
	styleUrls: ['./list.page.scss']
})
export class AgreementListPage extends ListPageBase<AgreementListItem> {

	agreementStates: KeyValueObject[] = [];
	engineers: KeyValueObject[] = [];

	public enableSaveGridSettings: boolean = true;
	public gridSettingsStorageKey: string = "agreements-grid-settings";
	public gridSettingsFilterStorageKey: string = "agreements-grid-filter-settings";

	public gridSettingsFilter: GridSettings = {
		state: {
			skip: 0,
			take: 100,
			sort: [{ field: 'createdDate', dir: 'desc' }],
			filter: { logic: 'and', filters: [] },
		},
		columnsConfig: [
			{
				orderIndex: 0,
				field: 'number',
				title: 'Номер договора',
				filter: 'string',
				filterable: true,
				width: 180,
				hidden: true
			},
			{
				orderIndex: 1,
				field: 'contragentName',
				title: 'Клиент',
				filter: 'string',
				filterable: true,
				width: 220,
				hidden: false
			},
			{
				orderIndex: 2,
				field: 'customerObjectName',
				title: 'Объект обслуживания',
				filter: 'string',
				filterable: true,
				width: 220,
				hidden: false
			},
			{
				orderIndex: 3,
				field: 'customerObjectFullAddress',
				title: 'Адрес',
				filter: 'string',
				filterable: true,
				width: 260,
				hidden: false
			},
			{
				orderIndex: 4,
				field: 'equipment',
				title: 'Оборудование',
				filter: 'string',
				filterable: true,
				width: 260,
				hidden: true
			},
			{
				orderIndex: 5,
				field: 'stateName',
				title: 'Статус',
				filter: 'lookup',
				filterable: true,
				width: 240,
				hidden: false
			},
			{
				orderIndex: 6,
				field: 'agreementDate',
				title: 'Дата заключения',
				filter: 'date',
				filterable: true,
				width: 300,
				hidden: true
			},
			{
				orderIndex: 7,
				field: 'endDate',
				title: 'Срок действия',
				filter: 'date',
				filterable: true,
				width: 300,
				hidden: true
			},
			{
				orderIndex: 8,
				field: 'serviceInterval',
				title: 'Интервал',
				filter: 'numeric',
				filterable: true,
				width: 180,
				hidden: true
			},
			{
				orderIndex: 9,
				field: 'completedVisitsCount',
				title: 'Выполнено визитов',
				filter: 'numeric',
				filterable: true,
				width: 180,
				hidden: true
			},
			{
				orderIndex: 10,
				field: 'cost',
				title: 'Стоимость',
				filter: 'numeric',
				filterable: true,
				width: 180,
				hidden: true
			},
			{
				orderIndex: 11,
				field: 'responsibleEngineerName',
				title: 'Ответственный инженер',
				filter: 'lookup',
				filterable: true,
				width: 220,
				hidden: false
			}
		]
	};

	public gridSettings: GridSettings = {
		state: {
			skip: 0,
			take: 100,
			sort: [{ field: 'createdDate', dir: 'desc' }],
			filter: { logic: 'and', filters: [] },
		},
		columnsConfig: [
			{
				orderIndex: 0,
				field: 'number',
				title: 'Номер договора',
				filter: 'string',
				filterable: true,
				width: 180,
				hidden: false
			},
			{
				orderIndex: 1,
				field: 'contragentName',
				title: 'Клиент',
				filter: 'string',
				filterable: true,
				width: 220,
				hidden: false
			},
			{
				orderIndex: 2,
				field: 'customerObjectName',
				title: 'Объект обслуживания',
				filter: 'string',
				filterable: true,
				width: 220,
				hidden: false
			},
			{
				orderIndex: 3,
				field: 'customerObjectFullAddress',
				title: 'Адрес',
				filter: 'string',
				filterable: true,
				width: 260,
				hidden: false
			},
			{
				orderIndex: 4,
				field: 'equipment',
				title: 'Оборудование',
				filter: 'string',
				filterable: true,
				width: 260,
				hidden: false
			},
			{
				orderIndex: 5,
				field: 'stateName',
				title: 'Статус',
				filter: 'lookup',
				filterable: true,
				width: 160,
				hidden: false
			},
			{
				orderIndex: 6,
				field: 'agreementDate',
				title: 'Дата заключения',
				filter: 'date',
				filterable: true,
				width: 180,
				hidden: false
			},
			{
				orderIndex: 7,
				field: 'endDate',
				title: 'Срок действия',
				filter: 'date',
				filterable: true,
				width: 180,
				hidden: false
			},
			{
				orderIndex: 8,
				field: 'serviceInterval',
				title: 'Интервал',
				filter: 'numeric',
				filterable: true,
				width: 120,
				hidden: false
			},
			{
				orderIndex: 9,
				field: 'completedVisitsCount',
				title: 'Выполнено визитов',
				filter: 'numeric',
				filterable: true,
				width: 160,
				hidden: false
			},
			{
				orderIndex: 10,
				field: 'cost',
				title: 'Стоимость',
				filter: 'numeric',
				filterable: true,
				width: 140,
				hidden: false
			},
			{
				orderIndex: 11,
				field: 'responsibleEngineerName',
				title: 'Ответственный инженер',
				filter: 'lookup',
				filterable: true,
				width: 220,
				hidden: false
			}
		]
	};

	constructor(
		protected appService: AppService,
		protected router: Router,
		protected dataService: AgreementsService,
		protected persistingService: StatePersistingService,
		private lookupService: LookupService,
		private usersService: UsersService,
		protected exportExcelFromGridService: ExportExcelFromGridService)
	{
		super(router, appService, dataService, persistingService, exportExcelFromGridService);
		appService.pageTitle = 'Сервисные договоры';
	}

	onListPageInit(): void {
		this.lookupService.getData('agreement-states', null).subscribe(data => this.agreementStates = data);
		this.usersService.getUserEngineers().subscribe(data => {
			this.engineers = (data || []).map(x => new KeyValueObject(x.userId, x.displayName));
		});
	}

	processListItems(items: AgreementListItem[]): void {

	}

	public cellClick({ dataItem }: any): void {
		this.router.navigate(['/categories/agreement', dataItem.agreementId]);
	}
}
